import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

export const ModalDeleteCategoria = (props) => {
	const {UseModalDeleteCategoria, setUseModalDeleteCategoria, deleteCategoria} = props;
	return (
		<>
			<Modal
				centered={true}
				isOpen={UseModalDeleteCategoria}
				toggle={() => setUseModalDeleteCategoria(false)}
			>
				<ModalHeader>
					<b>Eliminar categoria</b>
				</ModalHeader>
				<ModalBody>¿Seguro que desea eleminar la categoria?</ModalBody>
				<ModalFooter>
					<div className='buttons-modal-categoria'>
						<div
							className='button'
							onClick={() => setUseModalDeleteCategoria(false)}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button'
							onClick={() => deleteCategoria()}
						>
							<b>Eliminar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
};
